import React from 'react';
import styled from 'styled-components';

import { Link } from 'gatsby';

import commonLogo from '../images/common-logo.png';
import whyDungeonsLogo from '../images/why-dungeons-logo.png';
import wtlLogo from '../images/wtl-logo.png';
import treasureChestLogo from '../images/wtl-treasure-chest-logo.png';
import wtlGroupLogo from '../images/wtl-group-logo.png';

const ThePage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: 'Open Sans', sans-serif;
  background: #ffffff;
  background: -moz-linear-gradient(top,  #ffffff 0%, #f0f0f0 100%);
  background: -webkit-linear-gradient(top,  #ffffff 0%,#f0f0f0 100%);
  background: linear-gradient(to bottom,  #ffffff 0%,#f0f0f0 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f0f0f0',GradientType=0 );
`;

const PageSizeWrapper = styled.div`
  position: relative;
  max-width: 80vw;
  width: 100vw;
  height: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media all and (max-width: 968px) {
    max-width: unset;
  }
`;

const OptionImage = styled.img`
  width: 75px;
`;

const Header = styled.div`
  box-sizing: border-box;

  img {
    width: 100px;
    margin: 40px 20px;
  }

  @media all and (max-width: 968px) {
    img {
      margin: 40px auto;
      display: block;
    }
  }
`;

const Body = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);
`;

const OptionButton = styled.div`
  position: relative;
  display: inline-block;
  width: 200px;
  height: 200px;
  background-color: #fff;
  border-radius: 15px;
  color: #000;
  padding: 8px;
  margin: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0px 5px 10px #ccc;
  cursor: pointer;
  transition: all .1s ease;
  font-size: 11px;
  color: #ccc;

  & > div {
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    user-select: none;
    white-space: nowrap;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 10px 20px #ccc;
    color: #000;
  }
`;

export default class Index extends React.Component {
  componentDidMount() {
    sessionStorage.removeItem('_wtlshl');
  }

  render() {
    return (
      <ThePage>
        <Header>
          <PageSizeWrapper>
            <img src={wtlGroupLogo} />
          </PageSizeWrapper>
        </Header>
        <Body>
          <PageSizeWrapper>
            <Link to="/details">
              <OptionButton>
                <div>
                  <OptionImage src={wtlLogo} />
                  <div style={{ position: 'relative', top: 40 }}>
                    New WTL Studio Website
                  </div>
                </div>
              </OptionButton>
            </Link>
            <Link to="/common-app">
              <OptionButton>
                <div>
                  <OptionImage src={commonLogo} />
                  <div style={{ position: 'relative', top: 40 }}>
                    New Common Account
                  </div>
                </div>
              </OptionButton>
            </Link>
            <Link to="/why-dungeons">
              <OptionButton>
                <div>
                  <OptionImage src={whyDungeonsLogo} />
                  <div style={{ position: 'relative', top: 40 }}>
                    New WhyDungeons Account
                  </div>
                </div>
              </OptionButton>
            </Link>
            <Link to="/treasure-chest">
              <OptionButton>
                <div>
                  <OptionImage src={treasureChestLogo} />
                  <div style={{ position: 'relative', top: 40 }}>
                    New TreasureChest Account
                  </div>
                </div>
              </OptionButton>
            </Link>
          </PageSizeWrapper>
        </Body>
      </ThePage>
    );
  }
}